<template>
    <div class="container">
        <div class="d-flex align-items-center mb-1 justify-content-between p-1">
            <div class="d-flex align-items-center">
                <img height="40px" :src="require('@/assets/images/logo/derko-long-logo.png')" />
                <h3 class="mb-0 ml-2"><span class="font-weight-bolder">{{$param('company.name')}}</span> - <span class="text-muted">{{ code }}<template v-if="!unavailable && detail.CariName"> - {{detail.CariName}}</template></span></h3>
            </div>
            <feather-icon size="24" v-on:click="dark" :icon="`${isDark ? 'Sun' : 'Moon'}Icon`" class="mr-50 c-pointer" />
        </div>
        <b-card v-if="unavailable" class="mb-0" body-class="d-flex flex-column justify-content-center align-items-center text-center py-3 px-2">
            <b-img fluid width="320" :src="unavailableImg" class="mb-2" />
            <h3 class="text-danger mt-1 mb-1">Üzgünüz, şu anda ödeme yapılamıyor</h3>
            <p class="text-muted mb-0" style="max-width: 560px;">{{ unavailableMessage }}</p>
        </b-card>
        <b-overlay v-else :show="loading || bankLoading || campaignLoading" opacity="1">
            <b-card no-body class="mb-0">
                <div class="pt-1 px-1 mb-1">
                    <vue-perfect-scrollbar>
                        <table class="table table-sm table-bordered">
                            <thead>
                                <tr>
                                    <th class="text-nowrap w-10">Detay</th>
                                    <th class="text-nowrap w-15">Fatura Numarası</th>
                                    <th class="text-nowrap w-15">Fatura Kesim Tarihi</th>
                                    <th class="text-nowrap w-15">Ödenen Tutar (TL)</th>
                                    <th class="text-nowrap w-15">Kalan Tutar (TL)</th>
                                    <th class="text-nowrap w-30">Toplam Tutar (TL)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(d,_i) in detail.InvoiceDetails">
                                    <tr :key="d.DocumentNo">
                                        <td class="text-center">
                                            <button class="btn btn-sm btn-outline-secondary w-100" v-on:click="getFaturaDetail(d,_i)">
                                                <b-spinner small class="mr-50" v-if="currentIndex == _i"></b-spinner>
                                                <span>{{ !d.showDetail ? 'Göster' : 'Gizle'}}</span>
                                            </button>
                                        </td>
                                        <td class="text-nowrap">{{$safe(d,'DocumentNo') || "-"}}</td>
                                        <td class="text-nowrap">{{$safe(d,'Date') || "-"}}</td>
                                        <td class="text-nowrap bg-light-success">{{$safe(d,'PaidPart') || "-"}}</td>
                                        <td class="text-nowrap bg-light-secondary">{{$safe(d,'RemainingDebt') || "-"}}</td>
                                        <td class="text-nowrap bg-light-primary text-total">{{$safe(d,'Debt') || "-"}}</td>
                                    </tr>
                                    <tr :key="'detail'+d.DocumentNo" v-if="d.showDetail && ($safe(d,'InvoiceItems') || []).length > 0">
                                        <td colspan="6">
                                            <table class="table table-sm">
                                                <thead>
                                                    <th class="text-nowrap w-75">Ürün</th>
                                                    <th class="text-nowrap w-25">Miktar</th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item,index) in d.InvoiceItems" :key="item.Count + item.Price + item.ProductName + index">
                                                        <td class="text-nowrap font-weight-bolder">{{$safe(item,'ProductName') || '-'}}</td>
                                                        <td class="text-nowrap">{{$safe(item,'Count') || '-'}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                    <tr :key="'detail'+d.DocumentNo + 'empty'" v-if="d.showDetail && ($safe(d,'InvoiceItems') || []).length == 0">
                                        Fatura detayı bulunmamaktadır.
                                    </tr>
                                </template>
                                <tr>
                                    <td colspan="3" class="text-right font-weight-bolder">TOPLAM</td>
                                    <td class="font-weight-bolder bg-light-success">
                                        {{ detail.TotalPaidPart }}
                                    </td>
                                    <td class="font-weight-bolder bg-light-secondary">
                                        {{ detail.TotalRemainingDebtStr }}
                                    </td>
                                    <td class="font-weight-bolder bg-light-primary text-total">
                                        {{ detail.TotalAmountStr }}
                                    </td>
                                </tr>
                                <tr v-if="loading && (detail.InvoiceDetails || []).length == 0">
                                    <td colspan="6" class="text-center">Ödeme detayı yükleniyor.</td>
                                </tr>
                                <tr v-if="!loading && (detail.InvoiceDetails || []).length == 0">
                                    <td colspan="6" class="text-center">Ödeme detayı bulunamadı.</td>
                                </tr>
                            </tbody>
                        </table>
                    </vue-perfect-scrollbar>
                </div>
                <vue-perfect-scrollbar class="mx-1">
                    <div v-if="detail.CanInstallment" class="d-flex justify-content-lg-center">
                        <ul class="list-group w-100 list-group-horizontal-md mb-1">
                            <li class="list-group-item w-100 d-flex flex-column justify-content-between p-50 text-nowrap" v-for="c in campaigns" :key="c.Id" :class="['campaign',c.Bank].join('-')">
                                <div>{{$safe(c,'BankName')}}</div>
                                <span class="font-weight-bolder">{{$safe(c,'Campaign')}}</span>
                            </li>
                        </ul>
                    </div>
                </vue-perfect-scrollbar>
                <b-tabs pills active-nav-item-class="nav-pill-primary" class="px-1 pb-1" nav-class="bg-light p-25 custom-nav">
                    <b-tab title="Garanti" active title-link-class="bank-0" v-if="checkBank(0)">
                        <garanti-form   :bank-value="0" 
                                        :code="code" 
                                        :amount="paymentAmount" 
                                        :max-amount="maxPaymentAmount"
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="handleAmountChange"
                                        :can-installment="detail.CanInstallment"
                                        :installments="getBankInstallment(0)"></garanti-form>
                    </b-tab>
                    <b-tab title="İş Bankası" title-link-class="bank-2" v-if="checkBank(2)">
                        <is-bankasi-form    :bank-value="2" 
                                            :code="code" 
                                            :amount="paymentAmount" 
                                            :max-amount="maxPaymentAmount"
                                            :amount-str="detail.TotalAmountStr"
                                            v-on:update:amount="handleAmountChange"
                                            :can-installment="detail.CanInstallment"
                                            :installments="getBankInstallment(2)"></is-bankasi-form>
                    </b-tab>
                    <b-tab title="Akbank" title-link-class="bank-3" v-if="checkBank(3)">
                        <akbank-form    :bank-value="3" 
                                        :code="code" 
                                        :amount="paymentAmount" 
                                        :max-amount="maxPaymentAmount"
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="handleAmountChange"
                                        :can-installment="detail.CanInstallment"
                                        :installments="getBankInstallment(3)"></akbank-form>
                    </b-tab>
                    <b-tab title="Ziraat Bankası" title-link-class="bank-6" v-if="checkBank(6)">
                        <ziraat-bank-form    :bank-value="6" 
                                            :code="code" 
                                            :amount="paymentAmount" 
                                            :max-amount="maxPaymentAmount"
                                            :amount-str="detail.TotalAmountStr"
                                            v-on:update:amount="handleAmountChange"
                                            :can-installment="detail.CanInstallment"
                                            :installments="getBankInstallment(6)"></ziraat-bank-form>
                    </b-tab>
                    <b-tab title="Yapı Kredi" title-link-class="bank-1" v-if="checkBank(3)">
                        <yapi-kredi-form    :bank-value="1" 
                                            :code="code" 
                                            :amount="paymentAmount" 
                                            :max-amount="maxPaymentAmount"
                                            :amount-str="detail.TotalAmountStr"
                                            v-on:update:amount="handleAmountChange"
                                            :can-installment="detail.CanInstallment"
                                            :installments="getBankInstallment(1)"></yapi-kredi-form>
                    </b-tab>
                    <b-tab title="QNB Finansbank" title-link-class="bank-4" v-if="checkBank(4)">
                        <qnb-finansbank-form   :bank-value="4" 
                                            :code="code" 
                                            :amount="paymentAmount" 
                                            :max-amount="maxPaymentAmount"
                                            :amount-str="detail.TotalAmountStr"
                                            v-on:update:amount="handleAmountChange"
                                            :can-installment="detail.CanInstallment"
                                            :installments="getBankInstallment(4)"></qnb-finansbank-form>
                    </b-tab>
                    <!-- <b-tab title="Diğer" title-link-class="bank-5" v-if="checkBank(0)">
                        <other-form   :bank-value="5" 
                                        :code="code" 
                                        :amount="detail.TotalRemainingDebt" 
                                        :amount-str="detail.TotalAmountStr"
                                        v-on:update:amount="value=> detail.TotalRemainingDebt = value"
                                        :can-installment="detail.CanInstallment"
                                        :installments="[]"></other-form>
                    </b-tab> -->
                </b-tabs>
            </b-card>
        </b-overlay>
    </div>
</template>

<script> 
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { BOverlay,BCard,BTabs,BTab, BSpinner, BImg } from 'bootstrap-vue'
import GarantiForm from './components/GarantiForm.vue';
import IsBankasiForm from './components/IsBankasiForm.vue';
import AkbankForm from './components/AkbankForm.vue';
import ZiraatBankForm from './components/ZiraatBankForm.vue';
import YapiKrediForm from './components/YapiKrediForm.vue';
import QnbFinansbankForm from './components/QnbFinansbankForm.vue';
import OtherForm from './components/OtherForm.vue';
import { SystemDataApi } from '@/api/system-data';
import { SystemParameterApi } from '@/api/system-parameter'
import { PaymentApi } from '@/api/payment'
import useAppConfig from '@core/app-config/useAppConfig'
import VCurrencyInput from '@/components/VCurrencyInput.vue';
import { NetsisApi } from '@/api/netsis';
export default {
    components:{
        BOverlay,
        BCard,
        BTabs,
        BTab,
        BSpinner,
        BImg,
        VuePerfectScrollbar,
        GarantiForm,
        IsBankasiForm,
        ZiraatBankForm,
        AkbankForm,
        YapiKrediForm,
        QnbFinansbankForm,
        OtherForm,
        VCurrencyInput
    },
    data(){
        return{
            banks:[],
            loading:false,
            bankLoading:false,
            campaignLoading:false,
            code:this.$route.params?.code || null,
            campaigns:[],
            currentIndex:-1,
            unavailable:false,
            unavailableMessage:'',
            unavailableImg:require('@/assets/images/illustrations/payment-error.svg'),
            paymentAmount:0,
            maxPaymentAmount:0,
            detail:{
                TotalAmount:null,
                TotalAmountStr:null,
                CanInstallment:null,
                InvoiceDetails:[],
            }
        }
    },
    mounted(){
        this.getDetail()
        this.getBankInstallmentCampaign()
    },  
    methods:{
        getFaturaDetail(item,index){
            if(item.detailGetted){
                item.showDetail = !item.showDetail
            }else{
                this.currentIndex = index
                NetsisApi.FaturaDetay(this.detail.CariCode,item.DocumentNo).then(res=>{
                    this.currentIndex = -1
                    if(res.data.Success){
                        item.detailGetted = true
                        item.InvoiceItems = res.data.Data
                        item.showDetail = true
                    }else{
                        this.$result(res)
                    }
                }).catch(err=>{
                    this.currentIndex = -1
                    this.$result(null,err)
                })
            }
        },
        getDetail(){
            this.loading = true
            PaymentApi.GetDetail(this.code).then(res=>{
                if(res.data.Success){
                    this.detail = res.data.Data
                    this.maxPaymentAmount = Number(this.detail?.TotalRemainingDebt || 0)
                    this.paymentAmount = this.maxPaymentAmount
                    this.detail.InvoiceDetails = this.detail.InvoiceDetails.map(d=>{
                        return{
                            ...d,
                            showDetail:false,
                            detailGetted:false
                        }
                    })
                    this.getBanks(this.detail.IsSunProductInvoice)
                    this.loading = false
                }else{
                    this.loading = false
                    const message = res?.data?.Message || ''
                    if(message.includes('Ödeme yapılması gereken herhangi bir kayıt bulunamadı')){
                        this.unavailableMessage = message
                        this.unavailable = true
                    }else this.$result(res)
                }
            }).catch(err=>{
                this.$result(null,err)
            })
        },
        getBankInstallmentCampaign(){
            this.campaignLoading = true
            SystemParameterApi.BankInstallmentsCampaign().then(res=>{
                this.campaigns = res.data.Data
                this.campaignLoading = false
            })
        },
        getBanks(isSunProductInvoice){
            this.bankLoading = true
            let type = isSunProductInvoice ? 2 : 0
            SystemDataApi.Bank(type).then(res=> {
                this.banks = res.data.Data
                this.bankLoading = false
            })
        },
        dark(){
            const { skin } = useAppConfig()
            skin.value = this.isDark ? 'light' : 'dark'
        },
        checkBank(bankValue){
            return this.banks.map(b=>b.Value).includes(bankValue)
        },
        getBankInstallment(bankValue){
            let bank = this.banks.find(b=>b.Value == bankValue)
            return bank?.Installments || []
        },
        normalizeAmount(value){
            const amount = Number(value)
            if(!Number.isFinite(amount)) return 0
            return Number(amount.toFixed(2))
        },
        handleAmountChange(value){
            const maxAmount = this.normalizeAmount(this.maxPaymentAmount)
            const newAmount = this.normalizeAmount(value)
            if(newAmount < 0){
                this.paymentAmount = 0
                return
            }
            if(maxAmount > 0 && newAmount > maxAmount){
                this.paymentAmount = maxAmount
                return
            }
            this.paymentAmount = newAmount
        }
    },
    computed:{
        isDark(){
            const { skin } = useAppConfig()
            return skin.value === 'dark' ? true : false
        },
    }
}
</script>

<style>
.custom-nav .nav-link{
    margin: 0.25rem;
}
.custom-nav .nav-link:not(.active){
    border: 1px solid hsl(222, 17%, 85%);
    background-color: #ffffff;
}

.dark-layout .custom-nav .nav-link:not(.active){
    border: 1px solid hsl(222, 17%, 40%);
    background-color: #283046;
}
.nav-pill-primary.bank-0{
    background-color: rgb(31, 106, 4) !important;
    border-color: rgb(31, 106, 4) !important;
    box-shadow: 0 4px 18px -4px rgba(31, 106, 4, 0.65) !important;
}
.nav-pill-primary.bank-2{
    background-color: rgb(0, 67, 138) !important;
    border-color: rgb(0, 67, 138) !important;
    box-shadow: 0 4px 18px -4px rgba(0, 67, 138, 0.65) !important;
}
.nav-pill-primary.bank-3{
    background-color: rgb(224, 54, 42) !important;
    border-color: rgb(224, 54, 42) !important;
    box-shadow: 0 4px 18px -4px rgba(224, 54, 42, 0.65) !important;
}
.nav-pill-primary.bank-1{
    background-color: rgb(18, 75, 140) !important;
    border-color: rgb(18, 75, 140) !important;
    box-shadow: 0 4px 18px -4px rgba(18, 75, 140, 0.65) !important;
}

.campaign-0{
    color:rgba(31, 106, 4);
    background-color: rgba(31, 106, 4,0.1) !important;
}
.campaign-2{
    color:rgba(0, 67, 138);
    background-color: rgba(0, 67, 138,0.1) !important;
}
.campaign-3{
    color:rgba(224, 54, 42);
    background-color: rgba(224, 54, 42,0.1) !important;
}
.campaign-1{
    color:rgba(18, 75, 140);
    background-color: rgba(18, 75, 140,0.1) !important;
}

.text-total{
    color: var(--primary) !important;
}

.text-total-wo-tax{
    color: var(--secondary) !important;
}
.dark-layout .text-total{
    color: white !important
}

.currency-font-size{
    font-weight: bolder;
    height: 3rem !important;
    font-size: 2rem !important;
}
</style>
